import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { endpoint } from '..';
import Spinner from '../../../components/Spinner/Spinner';
import { IInitialState, RootState, getState } from '../../../reduxService';
  
import { useAppDispatch, useAppSelector } from '../../../reduxService/hooks';
/* import { IProjectResultResponse } from '../../MacRO1/api/IApiResponse';
import { IProjectMacro1 } from '../../MacRO1/store/project/projectSlice';
import { IProjectMacro2 } from '../../Macro2/store/project/projectSlice';*/
import { getActionByProjectType } from '../../actionMap';
import * as BeMaccaferriStoreHelper from '../../api/store/BeMaccaferriStoreHelper';
import Layout from '../../components/Layout/Layout';
import { EProjectType } from '../../enum/project';
import { selectProjectInfo, setProjectInfo } from '../../store/projectInfo/projectInfoSlice';
import { selectUser } from '../../store/user/userSlice';
/* import { saveProject } from '../../utils/utils'; */
import './DesignCondition.scss';
import { IDesignConditionProps } from './IDesignCondition';
import { Grid, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export const DesignCondition = (props: IDesignConditionProps) => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);

    const divResults = React.useRef<HTMLDivElement>(null);

    const [saved, setSaved] = React.useState(false);
    const [saveM2, setSaveM2] = React.useState(false);

    const [confirmMovement, setConfirmMovement] = React.useState(false);

    const [inResults, setInResults] = React.useState<boolean>();

    const { id } = useParams();
    const { projectType } = useParams();
    const [value, setValue] = React.useState(0);
    /*     if (projectInfo.initialState) {
            return <Navigate to={endpoint.home} replace={true} />;
        } */
    const { /* selectResults, selectProject, */ inputForm, graphic, results } = getActionByProjectType(projectType);

    const resultsData = useSelector((state: RootState) => state.Macro2.results.data?.outputData);
    const [showGeneralResult, setShowGeneralResult] = React.useState(false);
    React.useEffect(() => {
        const onBeforeUnload = (ev: BeforeUnloadEvent) => {
            ev.returnValue = '' + t('warnings.designConditions.message');
            return '' + t('warnings.designConditions.message');
        };
        window.addEventListener("beforeunload", onBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, []);

    React.useEffect(() => {
        setInResults(location.pathname.split("/")[1] == 'results');
        if (location.pathname.split("/")[1] == 'results' && divResults.current) {
            divResults.current.scrollIntoView();
        }
    }, [location.pathname]);

    React.useEffect(() => {
        //console.log('committedProjectData has changed', resultsData);
        // Add the code to run when resultsData changes
        setShowGeneralResult(!!resultsData);
    }, [resultsData]);

    /*     const project: IInitialState<IProjectMacro1 | IProjectMacro2> = useAppSelector(selectProject as any);
        const results: IInitialState<IProjectResultResponse> = useAppSelector(selectResults as any); */ //TODO aggiungi Macro2

    const handleSaveCloud = async () => {
        let pInfo = projectInfo.data!;
        let idForSave = projectInfo.data?.projectId ? projectInfo.data.projectId : !!id ? parseInt(id) : undefined;
        /*         await saveProject({ ...pInfo, id: idForSave }, true); */
    };

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    }

    React.useEffect(() => {
        if (saved) {
            handleSaveCloud();
        }
    }, [saved]);

    return (
        <Layout>
            <Grid container id="design-container">
                <Grid className='side-bar' item xs={12} md={3} lg={3}>
                    {inputForm}
                </Grid>
                <Grid className="canvas-area" item xs={12} md={9} lg={9}>
                    <Grid item xs={12} ref={divResults}>
                        {inResults ? results : graphic}
                    </Grid>
                </Grid>
            </Grid>
        </Layout>
    );
};
